module.exports = __webpack_public_path__ + "static/img/6.4cbeb5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/6.png
// module id = cq0D
// module chunks = 1